import * as angular from "angular";
import {IController} from "angular";

export class smsMessagesTableRowCtrl implements IController {

  smsMessage: any;

  constructor() {
  }

  $onInit() {
  };


}

angular
  .module('bringoz.admin.messages')
  .component('smsMessagesTableRow', {
    require: {
      smsMessagesTableCtrl: '^smsMessagesTable'
    },
    bindings: {
      smsMessage: '<'
    },
    template: require('./sms-messages-table-row.html').default,
    controller: smsMessagesTableRowCtrl
  });
